import isNetworkError from 'is-network-error'
import { isHTTPError, isTimeoutError } from 'ky'
import { api } from './api'

export type ShopPurchaseFailure =
  | { kind: 'connection' }
  | { kind: 'insufficient' }
  | { code: string; kind: 'rejected' }

export function classifyShopPurchaseFailure(
  error: unknown,
): ShopPurchaseFailure {
  if (
    isTimeoutError(error) ||
    (isNetworkError as (candidate: unknown) => boolean)(error)
  ) {
    return { kind: 'connection' }
  }
  // 422 means one thing on this endpoint: the priced currency was short
  // (GLOSSARY.md "Insufficient purchase balance"). Refresh tickets keep that
  // mapping (ADR 0032), on an open backend question — whether the server
  // also answers 422 when the client's ticket does not match its own
  // refresh tier, or when a purchase limit is hit. If it does, this has to
  // read the response body before calling a shortage.
  if (isHTTPError(error) && error.response.status === 422) {
    return { kind: 'insufficient' }
  }
  return {
    code: `shop_product_purchase: ${
      isHTTPError(error) ? error.response.status : String(error)
    }`,
    kind: 'rejected',
  }
}

export async function purchaseShopProduct(userId: number, productId: number) {
  await api.service
    .post(`store/users/${userId}/purchase`, {
      json: { product_id: productId, quantity: 1 },
    })
    .json<unknown>()
}
